import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Globalicon from './partials/Globalicon';
import LatestOffer from './LatestOffer';
import Exclusively from './Exclusively';
import About from './partials/About';
import NavbarVideo from './partials/NavbarVideo';
import Amenities from './partials/Amenities';
import OurClients from './partials/OurClients';

import HomePageBlog from "./partials/blogepage/HomePageBlog";


export default function Home() {
 const [loading, setLoading] = useState(true);


useEffect(() => {
    // Set timeout to remove loader after 3 seconds
    const timer = setTimeout(() => setLoading(false), 4500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
 <Helmet>
  <title>Best Hotel Near Delhi Airport | V Hotel The Grand Shoba  </title>
  <meta
    name="description"
    content="Stay at V Hotel The Grand Shoba, the best hotel near Delhi Airport, offering modern rooms, top amenities, and warm hospitality for business and leisure travelers."
  />
  
  <meta name="keywords" content="Best Hotel Near Delhi Airport ,3 Star Hotel Near Delhi, Best Room Near Delhi Airport, Deluxe Room Near Delhi Airport,Luxury Hotel Near Delhi Airport,Best Hotel Near Delhi Airport " />


  <link rel="canonical" href="https://www.vhotelthegrandshoba.com/" />


  <meta name="robots" content="index, follow" />

</Helmet>



 <div style={{ position: "relative", minHeight: "100vh" }}>
      {/* ✅ Logo Video Loader */}
      {loading && (
        <div
          style={{
            position: "fixed", // important to overlay entire screen
            top: 0,
            left: 0,
            zIndex: 9999,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0)", // light background
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
         
          <video
            // src="https://www.vhotelthegrandshoba.com/videos/logo.webm"
            src='/videos/logo.webm'
            autoPlay
            muted
            loop
            playsInline
            style={{
              width: "500px",
              height: "500px",
              objectFit: "contain",
            }}
          />
        </div>
      )}

      {/* 👇 Main Page Content */}
      <div style={{ filter: loading ? "blur(3px)" : "none" }}>
        <NavbarVideo />
        <About />
       {/* <ChatWid/> */}
        <Globalicon />
        <LatestOffer />
        <Exclusively />
        <HomePageBlog/>
        <OurClients />
        <Amenities />

        {/* <BlogCard/> */}
      </div>
    </div>


    </>
  );
}
